"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCourseDaysOfOperation = void 0;
const getCourseDaysOfOperation = (days_of_operation) => {
    const friendlyDays = {
        fri: "Fridays",
        mon: "Mondays",
        sat: "Saturdays",
        sun: "Sundays",
        thu: "Thursdays",
        tue: "Tuesdays",
        wed: "Wednesdays",
    };
    const days = days_of_operation;
    const daysClosed = Object.keys(days).filter((day) => !days[day] && day !== "hol");
    // order daysClosed by days of the week
    if (daysClosed.length > 0) {
        return `Closed on ${daysClosed
            .map((day) => friendlyDays[day])
            .join(" & ")}`;
    }
    return `Open every day`;
};
exports.getCourseDaysOfOperation = getCourseDaysOfOperation;
